// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Kk3m","info":"UpdateTermsInfo_info__2BW3t"};